var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "var-cross__container" },
    [
      _c("li", { staticClass: "var-cross__img-wrap" }, [
        _c(
          "div",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass:
              "var-cross__img-container var-cross__img-container--active",
            attrs: {
              title: _vm.replaceName(_vm.activeItemColorName),
              "data-toggle": "tooltip",
              "data-placement": "top",
              "data-original-title": _vm.activeItemColorName
            }
          },
          [
            _c("div", {
              staticClass: "var-cross__img",
              style: { backgroundImage: "url(" + _vm.activeItemColorUrl + ")" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.crossItems, function(item) {
        return [
          _c("li", { staticClass: "var-cross__img-wrap" }, [
            _c(
              "a",
              {
                directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                staticClass: "var-cross__img-container",
                attrs: {
                  title: _vm.replaceName(item.colorname),
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  "data-original-title": item.colorname,
                  href: item.url
                }
              },
              [
                _c("div", {
                  staticClass: "var-cross__img",
                  style: { backgroundImage: "url(" + item.imgUrl + ")" }
                })
              ]
            )
          ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }